export type OemType =
  | 'CHAMPAGNE'
  | 'CAVA'
  | 'PROSECCO'
  | 'ASTI_SPUMANTE'
  | 'OTHER';

export const OemType = {
  champagne: 'CHAMPAGNE' as OemType,
  cava: 'CAVA' as OemType,
  prosecco: 'PROSECCO' as OemType,
  astiSpumante: 'ASTI_SPUMANTE' as OemType,
  other: 'OTHER' as OemType,
};
